import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';

export const ScreenContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const ButtonContainer = styled.div`
  .submitContainer {
    margin: 48px 0px 48px 0px;
  }
  .link {
    color: ${COLORS.darkBlue};
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 16px;
    font-style: normal;
    line-height: 26px;
    margin-top: 24px;
    cursor: pointer;
  }
`;

type ModalContainerProps = {
  height?: number;
  width?: number;
  buttonWidth?: number;
  buttonTopMargin?: number;
  containerMarginTop?: number;
};

export const ModalContainer = styled.div<ModalContainerProps>`
  background: ${COLORS.white};
  width: ${({ width }) => width}px;
  border-radius: 4px;
  min-height: ${({ height }) => height}px;
  gap: 32px;
  padding: 16px 16px 32px 16px;

  .navigationContainer {
    float: right;
  }
  .closeButton {
    cursor: pointer;
  }

  .modalBodyContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-top: ${(props) => props.containerMarginTop}px;

    .headerContainer {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: 0;
      align-items: center;
      margin-bottom: 32px;

      .aadharMobileNotLinked {
        color: ${COLORS.textGrey};
        font-family: ${FONT_FAMILY.hellix.bold};
        text-align: center;
        font-size: 18px;
        font-style: normal;
        line-height: 26px;
        margin: 16px 40px 16px 40px;
      }
      .aadharNotLinked {
        color: ${COLORS.textGrey};
        font-family: ${FONT_FAMILY.hellix.bold};
        text-align: center;
        font-size: 18px;
        font-style: normal;
        line-height: 26px;
        margin: 8px 0;
      }
      .linkAadhar {
        font-family: ${FONT_FAMILY.hellix.regular};
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: ${COLORS.textGrey};
      }
      .setUpTransfer {
        font-family: ${FONT_FAMILY.hellix.regular};
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        margin-top: 32px;
        color: ${COLORS.textGrey};
      }
    }
  }

  @media ${DEVICES.mobileL} {
    .submitButton,
    .submit-button-disabled {
      width: 100% !important;
    }
  }
`;

export const LoaderImage = styled.img`
  width: 100px !important;
  height: 100px !important;
`;
export const AadharSuccessContainer = styled.div`
  .fetchingDetails {
    color: ${COLORS.black};
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 28px;
    font-style: normal;
    line-height: 38px;
    margin: -30px 0px 8px 0px;
  }

  .aadharVerified {
    color: ${COLORS.black};
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 28px;
    font-style: normal;
    line-height: 38px;
    margin: 32px 0px 8px 0px;
  }
  .redirectingShortly {
    color: ${COLORS.textGrey};
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
`;

export const IframeContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;
